<template>
  <div>
    <custom-callout
      :border-color="getBorderColor"
      class="mb-4 custom-callout bg-white"
      :custom-class="getBorderColor"
      :has-toggle="false"
    >
      <div class="d-flex ml-2">
        <div class="flex-grow-1">
          <div class="flex-grow-1 color-gray-6 font-14">
            {{ mainTitle }}
          </div>
          <div class="color-black font-weight-bold font-25">{{ count }}</div>
        </div>
        <action-button
          class="d-none d-md-block d-sm-none"
          i="fas fa-print"
          variant="outline-success"
          @click="$emit('print')"
        />
      </div>
      <hr class="mt-2" />
      <div class="font-14 color-gray-6 h-25">
        {{ description }}
      </div>
      <action-button
        class="d-block d-md-none d-sm-block mt-3"
        i="fas fa-print"
        variant="outline-success w-100"
        @click="$emit('print')"
      />
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import { ActionButton } from '@/components/common';
export default {
  name: 'ServiceAlertView',
  components: {
    CustomCallout,
    ActionButton,
  },
  props: {
    mainTitle: {
      type: String,
      default: () => '',
    },
    count: {
      type: Number,
      default: () => 0,
    },
    description: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    getBorderColor() {
      return this.count > 0 ? 'red' : 'green';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
::v-deep .callout-container {
  background: map-get($colors, 'white') !important;
  border-top: 1px solid map-get($colors, 'gray-5') !important;
  border-right: 1px solid map-get($colors, 'gray-5') !important;
  border-bottom: 1px solid map-get($colors, 'gray-5') !important;

  border-left-width: 4px !important;
}
::v-deep .outline-success {
  padding-left: 0px;
  i {
    font-size: 20px;
    padding-left: 8px;
    padding-right: 0px !important;
  }
}
</style>
